// Generated by art-masters/v10/orbit.sh — 36 frames of the Mountain orbit (10° each).
import type { ImageSourcePropType } from 'react-native';
export const ORBIT_FRAMES: ImageSourcePropType[] = [
  require('../../assets/v10/mountain/orbit/f00.jpg'),
  require('../../assets/v10/mountain/orbit/f01.jpg'),
  require('../../assets/v10/mountain/orbit/f02.jpg'),
  require('../../assets/v10/mountain/orbit/f03.jpg'),
  require('../../assets/v10/mountain/orbit/f04.jpg'),
  require('../../assets/v10/mountain/orbit/f05.jpg'),
  require('../../assets/v10/mountain/orbit/f06.jpg'),
  require('../../assets/v10/mountain/orbit/f07.jpg'),
  require('../../assets/v10/mountain/orbit/f08.jpg'),
  require('../../assets/v10/mountain/orbit/f09.jpg'),
  require('../../assets/v10/mountain/orbit/f10.jpg'),
  require('../../assets/v10/mountain/orbit/f11.jpg'),
  require('../../assets/v10/mountain/orbit/f12.jpg'),
  require('../../assets/v10/mountain/orbit/f13.jpg'),
  require('../../assets/v10/mountain/orbit/f14.jpg'),
  require('../../assets/v10/mountain/orbit/f15.jpg'),
  require('../../assets/v10/mountain/orbit/f16.jpg'),
  require('../../assets/v10/mountain/orbit/f17.jpg'),
  require('../../assets/v10/mountain/orbit/f18.jpg'),
  require('../../assets/v10/mountain/orbit/f19.jpg'),
  require('../../assets/v10/mountain/orbit/f20.jpg'),
  require('../../assets/v10/mountain/orbit/f21.jpg'),
  require('../../assets/v10/mountain/orbit/f22.jpg'),
  require('../../assets/v10/mountain/orbit/f23.jpg'),
  require('../../assets/v10/mountain/orbit/f24.jpg'),
  require('../../assets/v10/mountain/orbit/f25.jpg'),
  require('../../assets/v10/mountain/orbit/f26.jpg'),
  require('../../assets/v10/mountain/orbit/f27.jpg'),
  require('../../assets/v10/mountain/orbit/f28.jpg'),
  require('../../assets/v10/mountain/orbit/f29.jpg'),
  require('../../assets/v10/mountain/orbit/f30.jpg'),
  require('../../assets/v10/mountain/orbit/f31.jpg'),
  require('../../assets/v10/mountain/orbit/f32.jpg'),
  require('../../assets/v10/mountain/orbit/f33.jpg'),
  require('../../assets/v10/mountain/orbit/f34.jpg'),
  require('../../assets/v10/mountain/orbit/f35.jpg'),
];
